
class BaseResponse {
    constructor(responseCode = 200) {
        this.responseCode = responseCode;
    }
}

export default BaseResponse;